module.exports = __webpack_public_path__ + "static/media/posMachines.1f193b5a.svg";